ACC.zippaycheckoutpost = {
    _autoload: [
        'bindZipPayUseDeliveryAddress',
        'bindZipPayAddressForm',
        ['bindSavedAddress', $('.zipPayRadioBtn').length !== 0],
        ['updateBillingAddressForm', $('#zipPayBillingCountrySelector').length
        && !$('#zipPayUseDeliveryAddress').length]],

    spinner: $(`<img src='${ACC.config.commonResourcePath}/images/spinner.gif' />`),

    bindZipPayUseDeliveryAddress() {
        const component = $('#zipPayUseDeliveryAddress');
        if (!component.length) return;
        component.on('change', () => {
            if (component.is(':checked')) {
                ACC.zippaycheckoutpost.hideBillingAddressForm();
                ACC.zippaycheckoutpost.preFillBillingForm();
                ACC.checkoutPreValid.toggleZipPayCheckoutBtn();
            } else {
                ACC.zippaycheckoutpost.showBillingAddressForm();
                ACC.zippaycheckoutpost.clearAddressForm();
                ACC.zippaycheckoutpost.enableAddressForm();
                ACC.checkoutPreValid.toggleZipPayCheckoutBtn();
            }
        });
        ACC.zippaycheckoutpost.toggleBillingAddressForm(component);
    },

    updateBillingAddressForm() {
        const countrySelection = $('#zippay\\.address\\.country option:selected').val();
        const options = {
            countryIsoCode: countrySelection,
            useDeliveryAddress: false,
            paymentType: 'ZIPPAY',
        };
        ACC.zippaycheckoutpost.displayBillingAddressForm(options);
    },

    toggleBillingAddressForm(component) {
        const hasPaymentErrors = $('#zipPayUseBillingAddressData').data('haspaymenterrors');
        const deliveryAddressId = $('#zipPayUseDeliveryAddressData').data('address-id');
        const billingAddressId = $('#zipPayUseBillingAddressData').data('address-id');
        if (component.data('is-quote-checkout') || hasPaymentErrors) {
            component.prop('checked', false);
            ACC.zippaycheckoutpost.showBillingAddressForm();
            if (hasPaymentErrors && (deliveryAddressId !== billingAddressId)) {
                ACC.zippaycheckoutpost.preFillBillingFormWhenPaymentError();
            } else if (hasPaymentErrors && (deliveryAddressId === billingAddressId)) {
                component.prop('checked', true);
                ACC.zippaycheckoutpost.hideBillingAddressForm();
                ACC.zippaycheckoutpost.preFillBillingForm();
            } else {
                ACC.zippaycheckoutpost.preFillBillingFormForQuoteCheckout();
            }
        } else if ($('.floated-sidebar').length !== 0) {
            component.prop('checked', true);
            ACC.zippaycheckoutpost.showBillingAddressForm();
        } else {
            component.prop('checked', true);
            ACC.zippaycheckoutpost.hideBillingAddressForm();
            ACC.zippaycheckoutpost.preFillBillingForm();
        }
    },

    displayBillingAddressForm(options, callback) {
        $.ajax({
            url: `${ACC.config.encodedContextPath}/checkout/multi/sop/billingaddressform`,
            async: false,
            data: options,
            dataType: 'html',
            beforeSend() {
                $('#zipPayBillingAddressForm').html(ACC.zippaycheckoutpost.spinner);
            },
        }).done((data) => {
            $('#billingAddressFormZipPay').html(data);
            if (typeof callback === 'function') {
                callback.call();
            }
            ACC.zippay.bindBillingAddressListeners();
            ACC.phonemasking.bind($('#zippay\\.address\\.phone'), options.countryIsoCode);
        });
    },

    preFillBillingFormWhenPaymentError() {
        const options = {
            countryIsoCode: $('#zipPayUseBillingAddressData').data('countryisocode'),
            useDeliveryAddress: false,
            hasPaymentErrors: true,
            paymentType: 'ZIPPAY',
        };
        ACC.zippaycheckoutpost.enableAddressForm();
        ACC.zippaycheckoutpost.displayBillingAddressForm(options, ACC.zippaycheckoutpost.fillCountrySelectBox);
    },

    preFillBillingFormForQuoteCheckout() {
        const options = {
            countryIsoCode: $('#zipPayUseDeliveryAddressData').data('countryisocode'),
            useDeliveryAddress: false,
            paymentType: 'ZIPPAY',
        };
        ACC.zippaycheckoutpost.enableAddressForm();
        ACC.zippaycheckoutpost.displayBillingAddressForm(options, ACC.zippaycheckoutpost.fillCountrySelectBox);
    },

    preFillBillingForm() {
        const options = {
            countryIsoCode: $('#zipPayUseDeliveryAddressData').data('countryisocode'),
            useDeliveryAddress: true,
            paymentType: 'ZIPPAY',
        };
        ACC.zippaycheckoutpost.enableAddressForm();
        ACC.zippaycheckoutpost.displayBillingAddressForm(options, ACC.zippaycheckoutpost.useDeliveryAddressSelected);
        ACC.zippaycheckoutpost.disableAddressForm();
    },

    fillCountrySelectBox(countryIsoCode) {
        const country = $('#zippay\\.address\\.country');

        if (ACC.global.isUndefinedOrNull(countryIsoCode)) {
            country.val($('#zipPayUseDeliveryAddressData').data('countryisocode'));
        } else {
            country.val(countryIsoCode);
        }
    },

    useDeliveryAddressSelected() {
        if ($('#zipPayUseDeliveryAddress').is(':checked')) {
            ACC.zippaycheckoutpost.fillCountrySelectBox();
            ACC.zippaycheckoutpost.disableAddressForm();
        } else {
            ACC.zippaycheckoutpost.clearAddressForm();
            ACC.zippaycheckoutpost.enableAddressForm();
        }
    },

    showBillingAddressForm() {
        $('#zipPayCcBillingAddressForm').fadeIn();
        $('#zipPayCcDeliveryAddress').hide();
    },

    hideBillingAddressForm() {
        $('#zipPayCcBillingAddressForm').hide();
        $('#zipPayCcDeliveryAddress').fadeIn();
    },

    enableAddressForm() {
        $('input[id^="zippay\\.address\\."]').prop('disabled', false);
        $('select[id^="zippay\\.address\\."]').prop('disabled', false);
        $('select.form-control').prev().removeClass('disabled');
    },

    clearAddressForm() {
        $('input[id^="zippay\\.address\\."]').val('');
        $('select[id^="zippay\\.address\\."]').filter(function () {
            return !this.id.match(/country/);
        }).val('');
    },

    disableAddressForm() {
        $('input[id^="zippay\\.address\\."]').prop('disabled', true);
        $('select[id^="zippay\\.address\\."]').prop('disabled', true);
        $('select.form-control').prev().addClass('disabled');
    },

    showPlaceOrderBtn() {
        $('.zippay-checkout-form').fadeIn();
    },

    bindZipPayAddressForm() {
        $('#zipPayBillingCountrySelector :input').on('change', ACC.zippaycheckoutpost.updateBillingAddressForm);
    },

    showPaymentForm() {
        $('.zippay-checkout-paymentmethod').fadeIn();
    },

    bindSavedAddress() {
        const component = $('.zipPayRadioBtn');
        component.on('change', function () {
            if (component.is(':checked')) {
                const selectedComponent = $(this);
                $('.selected').removeClass('selected');
                selectedComponent.parent().toggleClass('selected');

                if (selectedComponent.attr('id') === 'zipPayType') {
                    const useDeliveryAddress = $('#zipPayUseDeliveryAddress');
                    ACC.zippaycheckoutpost.toggleBillingAddressForm(useDeliveryAddress);
                }

                $('#payPalType').prop('checked', false);
                $('#payinternType').prop('checked', false);
                $('#savedCard-newCard').prop('checked', false);
                ACC.zippaycheckoutpost.showPlaceOrderBtn();
            }
        });
    },
};
